import Cookies from 'js-cookie'
import website from './website'

// token
export function getToken() {
  return Cookies.get(website.auth.userKey)
}

export function setToken(token) {
  return Cookies.set(website.auth.userKey, token)
}

export function removeToken() {
  sessionStorage.removeItem('tab')
  localStorage.removeItem('SystemId')
  return Cookies.remove(website.auth.userKey)
}


// 用户权限列表
export function getMenus() {
  return Cookies.get(website.auth.permissionInfo)
}

export function setMenus(info) {
  return Cookies.set(website.auth.permissionInfo, info)
}

export function removeMenus() {
  return Cookies.remove(website.auth.permissionInfo)
}


//用户按钮权限
export function getBtn() {
  return Cookies.get(website.auth.btnPermission)
}

export function setBtn(butType) {
  return Cookies.set(website.auth.btnPermission, butType)
}

export function removeBtn() {
  return Cookies.remove(website.auth.btnPermission)
}

// 用户登录信息
export function getInfo() {
  return Cookies.get(website.auth.userInfo)
}

export function setInfo(info) {
  return Cookies.set(website.auth.userInfo, info)
}

export function removeInfo() {
  return Cookies.remove(website.auth.userInfo)
}
// 路由表
export function getRouter() {
  return Cookies.get(website.auth.routerMap)
}

export function setRouter(info) {
  return Cookies.set(website.auth.routerMap, info)
}

export function removeRouter() {
  return Cookies.remove(website.auth.routerMap)
}


export function getComponent(tmp){
  let address = tmp.routingAddress;
  let path = '';
  let comp = '';
  if(address.indexOf('|') != -1){
    address = address.split('|');
    path = address[0];
    comp = address[1];
  }
  let t = {
      path: path,
      name: tmp.componentName,
      component: address,
      meta: {
        title: tmp.resourceNameShow
      }
    }
  return t;
}
export function filterAsyncRouter(routes,res) {

  routes.forEach(route => {
    const tmp = { ...route }
      if (tmp.children) {
        if(tmp.resourceType==4){
          //路由和组件地址相关联
          let item = getComponent(tmp);
          res.push(item)
        }
        tmp.children = filterAsyncRouter(tmp.children,res)
      }else{
        if(tmp.resourceType==4){
          let item = getComponent(tmp );
          res.push(item)
        }
      }
  })

  return res
}



// WEBPACK FOOTER //
// ./src/utils/auth.js